module.exports = __webpack_public_path__ + "img/banner-svg-2.305726ed.svg";